// @flow
import update from 'immutability-helper';
import { DEFAULT_LOCALE } from '../../../modules/locale/duck';
import { processLanguage } from '../../../modules/locale/utils';

import lima from '../../../assets/img/countries/01-Lima.png';
import bogota from '../../../assets/img/countries/02-Bogota.png';
import washington from '../../../assets/img/countries/03-Washington.png';
import usFlag from '../../../../node_modules/flag-icon-css/flags/1x1/us.svg';
import peFlag from '../../../../node_modules/flag-icon-css/flags/1x1/pe.svg';
import coFlag from '../../../../node_modules/flag-icon-css/flags/1x1/co.svg';

import type { Country, CountryFull } from '../../../entities/country';

export type LocalValueCountry = {
  key: Country;
  icon: string;
  image: string;
  phonePrefix: string;
  translateId: string;
};

const DEFAULT_COUNTRIES: LocalValueCountry[] = [
  {
    key: 'PE',
    icon: peFlag,
    image: lima,
    phonePrefix: '+51',
    translateId: 'country.pe',
  },
  {
    key: 'US',
    icon: usFlag,
    image: washington,
    phonePrefix: '+01',
    translateId: 'country.us',
  },
  {
    key: 'CO',
    icon: coFlag,
    image: bogota,
    phonePrefix: '+57',
    translateId: 'country.co',
  },
];

function populateCountries(countries: CountryFull[]): LocalValueCountry[] {
  return countries.map((c: CountryFull) => {
    let key = 'XX';
    let icon = '';
    let image = '';
    let phonePrefix = '';
    let translateId = '';

    const foundCountry = DEFAULT_COUNTRIES.find((fc: LocalValueCountry) => fc.key === c.code);
    if (foundCountry) {
      key = foundCountry.key;
      icon = foundCountry.icon;
      image = foundCountry.image;
      phonePrefix = foundCountry.phonePrefix;
      translateId = foundCountry.translateId;
    }
    return update(c, {
      key: { $set: key },
      icon: { $set: icon },
      image: { $set: image },
      phonePrefix: { $set: phonePrefix },
      translateId: { $set: translateId },
    });
  });
}

function indexCountriesById(countries: LocalValueCountry[]): { [key: string]: LocalValueCountry } {
  return countries.reduce((acum: { [key: string]: LocalValueCountry }, c: LocalValueCountry) =>
    update(acum, { [c.key]: { $set: c } }), {});
}

function getLocalizedCountry(country: Country, formatMessage: (value: { [id: string]: string }) => string,
                             countriesMap?: { [key: string]: LocalValueCountry }) {
  return countriesMap ? formatMessage({ id: countriesMap[country].translateId }) : '';
}

function getBrowserLanguage(): string {
  let browserLang = DEFAULT_LOCALE;
  if (navigator && navigator.language) {
    const processedLang = processLanguage(navigator.language);
    if (processedLang) {
      browserLang = processedLang;
    }
  }
  browserLang = browserLang.toUpperCase();
  return browserLang;
}

export {
  DEFAULT_COUNTRIES,
  populateCountries,
  indexCountriesById,
  getLocalizedCountry,
  getBrowserLanguage,
};




// WEBPACK FOOTER //
// ./src/modules/local-values/utils/countries.js